<template>
    <div>
        <div class="card-body" style="height: 100px;">
            <el-form label-width="90px" :label-position="'right'">
                <el-row :gutter="10">
                    <el-form-item label="员工:">
                        <el-select v-model="$parentInfo.dialog_storeHeadTeacher.employee_id"
                                   filterable remote
                                   clearable
                                   placeholder="请选择"
                                   :remote-method="handleSearchEmployee">
                            <el-option
                                    v-for="item in $parentInfo.search_employees"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div style="text-align: right">
            <el-button type="primary" size="small" @click="handleGive()" v-loading="$parentInfo.dialog_storeHeadTeacher.button_loading">确 定</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_StoreHeadTeacher",
        data() {
            return {

            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInit();
        },
        methods: {
            handleInit() {
                this.$wApi.send(this.$parentInfo.path, 'init_employee', {});
            },
            handleSearchEmployee(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type': 'searchEmployee',
                    'employeeKeyName': query,
                })
            },
            handleGive() {
                this.$parentInfo.dialog_storeHeadTeacher.loading = true;
                this.$wApi.send(this.$parentInfo.path, 'store_headTeacher', {
                    'employee_id': this.$parentInfo.dialog_storeHeadTeacher.employee_id,
                })
            },
        }
    }
</script>

<style scoped>

</style>